interface ValuePropCardProps {
  title: string;
}

export function ValuePropCard({ title }: ValuePropCardProps) {
  return (
    <div className="item">
      <div className="section-masthead__heading">
        <h3 className="h3 mt-0 mb-0">{title}</h3>
      </div>
    </div>
  );
}
